import { put, select, takeEvery } from 'redux-saga/effects';
import { TARIF_CHECKED } from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { selectSelectedVersSumme } from '../../app/shared/selectors/produkt.selector';
import { PhActions } from '../phActions';

export function* watchVersicherungssummen() {
  yield takeEvery(PhActions.ZUM_ANGEBOT_BUTTON_CLICKED, safeSaga(changeVersicherungssumme, App.PH));
  yield takeEvery(TARIF_CHECKED, safeSaga(changeVersicherungssumme, App.PH));
}

export function* changeVersicherungssumme() {
  const versSummeLeistung: number = yield select(selectSelectedVersSumme);
  if (versSummeLeistung) {
    yield put(new PhActions().versicherungsSummeChanged(versSummeLeistung));
  }
}
